<template>
  <div :class="$style.row">
    <ItemRow>
      <ItemWithLabel
        :class="$style.displayFlex"
        :column="columns[0]"
      >
        <Checkbox
          :class="$style.itemLabelMarginRight"
        />
        <StatusBadge
          :class="$style.badgeMargin"
          :status="findStatus"
          :text="itemData.status"
        />
        <span :class="$style.badgeLabel">Retry</span>
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.itemLabelMarginLeft"
        :column="columns[1]"
      >
        {{ itemData.deviceName }}
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.marginLeftSpacer"
        :column="columns[2]"
      >
        {{ itemData.commandTimestamp }}
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.marginLeftSpacer"
        :column="columns[3]"
      >
        <ButtonSecondary
          text="View"
        />
      </ItemWithLabel>
    </ItemRow>
  </div>
</template>

<script>
import {
  ButtonSecondary,
  Checkbox,
  ItemRow,
  ItemWithLabel,
  StatusBadge,
} from '@jumpcloud/ui-components';

export default {
  name: 'GoogleAppsStatusRow',
  components: {
    ButtonSecondary,
    Checkbox,
    ItemRow,
    ItemWithLabel,
    StatusBadge,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },

  computed: {
    findStatus() {
      switch (this.itemData.status) {
        case 'Command Sent':
          return 'success';
        case 'Install Pending':
          return 'warning';
        default:
          return 'informational';
      }
    },
  },
};
</script>

<style module>
.row {
  border-bottom: var(--jc-border);
}

.marginLeftSpacer {
  margin-left: var(--jc-spacer);
}

.displayFlex {
  display: flex;
}

.itemLabelMarginLeft {
  margin-left: 2.063rem;
}

.itemLabelMarginRight {
  margin-right: 2.063rem;
}

.badgeMargin {
  margin-top: -0.188rem;
}

.badgeLabel {
  margin-left: var(--jc-spacer-small);
  text-align: center;
}
</style>
